<template>

  <div v-if="show" class="modal-overlay">

    <div class="modal-dialog">

      <div class="modal-content">

        <!-- HEADER -->
        <div class="modal-header">
          <h5 style="margin: 0px!important">Заказ #{{ orderId }}</h5>
          <button class="close-btn" @click="$emit('close')">✕</button>
        </div>


        <div class="modal-body">

          <!-- SKELETON -->
          <div v-if="loading" class="skeleton">

            <div class="skeleton-line w40"></div>
            <div class="skeleton-line w60"></div>

            <div class="skeleton-table">
              <div class="skeleton-row" v-for="i in 4" :key="i"></div>
            </div>

          </div>


          <!-- CONTENT -->
          <div v-if="order && !loading">


            <!-- ORDER INFO -->
            <div class="order-meta">

              <div class="meta-row">
                <span class="meta-label">Адрес выдачи</span>
                <span class="meta-value">
                г. Минск ул. Багратиона, 35
              </span>
              </div>

              <div class="meta-row">
                <span class="meta-label">Номер заказа</span>
                <span class="meta-value">
                #{{ order.id }}
              </span>
              </div>

              <div class="meta-row">
                <span class="meta-label">Статус</span>
                <span class="meta-value status">
                {{ statusName(order.status) }}
              </span>
              </div>

              <div class="meta-row">
                <span class="meta-label">Время выдачи</span>
                <span class="meta-value">
                {{ order.timeRentStart || "—" }}
              </span>
              </div>

              <div class="meta-row">
                <span class="meta-label">Дата выдачи</span>
                <span class="meta-value">
                {{ formatDate(order.rentStartDate.date) }}
              </span>
              </div>

              <div class="meta-row">
                <span class="meta-label">Дата возврата</span>
                <span class="meta-value">
                {{ formatDate(order.rentEndDate.date) }}
              </span>
              </div>

              <div class="meta-row">
                <span class="meta-label">Ваша скидка</span>
                <span class="meta-value discount">
                  {{ discountInfo.text }} = {{ discountInfo.amount }} BYN
                </span>
              </div>

            </div>


            <!-- CLIENT -->
            <div class="client-card">

              <div class="client-row">
                <span class="client-label">Клиент</span>
                <span class="client-value">{{ order.client?.name || "—" }}</span>
              </div>

              <div class="client-row">
                <span class="client-label">Телефон</span>
                <span class="client-value">{{ order.client?.phone || "—" }}</span>
              </div>

              <div class="client-row">
                <span class="client-label">Доп. телефон</span>
                <span class="client-value">{{ order.client?.additionalPhone || "—" }}</span>
              </div>

              <div class="client-row">
                <span class="client-label">Email</span>
                <span class="client-value">{{ order.client?.email || "—" }}</span>
              </div>

            </div>
            <div class="client-row">
              <span class="client-label">Комментарий</span>
              <span class="client-value">{{ order.client?.additionalInfo || "—" }}</span>
            </div>


            <!-- PRODUCTS -->
            <table class="products-table">

              <thead>
              <tr>
                <th>Товар</th>
                <th>Кол-во</th>
                <th>Цена</th>

                <th>Скидка</th>
                <th>Итого</th>
              </tr>
              </thead>

              <tbody>

              <tr v-for="item in order.orderItems" :key="item.productId">

                <td class="product-name">
                  {{ item.productName }}
                </td>

                <td>
                  {{ item.quantity }}
                </td>

                <td>
                  {{ Number(item.price).toFixed(2) }} BYN
                </td>

                <td>
                <span class="discount-badge">
                  {{ item.discount }}%
                </span>
                </td>

                <td>
                  {{ itemTotal(item, order) }} BYN
                </td>

              </tr>

              </tbody>

            </table>


            <!-- TOTALS -->
            <div class="totals">

              <div class="totals-grid">

                <div class="total-row">
                  <span>Залог</span>
                  <span>{{ order.securityDepositAmount }} BYN</span>
                </div>

                <div class="total-row">
                  <span>Доставка</span>
                  <span>{{ order.delivery }} BYN</span>
                </div>

                <div class="total-row">
                  <span>Монтаж</span>
                  <span>{{ order.ustanovka }} BYN</span>
                </div>

                <div class="total-row">
                  <span>Чистка + Сушка</span>
                  <span>{{order.sborka}} BYN</span>
                </div>

              </div>

              <div class="total-row total">
                <span>Итого</span>
                <span>{{ order.paymentAmount }} BYN</span>
              </div>

              <div class="total-row discount">
                <span>Со скидкой</span>
                <span>{{ order.endPrice }} BYN</span>
              </div>

              <div class="total-row paid">
                <span>Оплачено</span>
                <span>{{ order.oplacheno }} BYN</span>
              </div>

            </div>

          </div>

        </div>

      </div>

    </div>

  </div>

</template>


<script>
import axios from "@/axios"

export default {

  name: "OrderInfoModal",

  props: {
    show: Boolean,
    orderId: Number
  },

  data() {
    return {
      loading: false,
      order: null
    }
  },

  watch: {

    show(v) {

      if (v) {
        this.order = null
        this.load()
      }

    }

  },

  computed: {
    discountInfo() {

      if (!this.order || !this.order.orderItems) {
        return {
          text: "—",
          amount: "0.00"
        }
      }

      const discounts = []
      let totalDiscount = 0

      const days = this.getDaysDifference(
          this.order.rentStartDate.date,
          this.order.rentEndDate.date
      )

      this.order.orderItems.forEach(item => {

        const base = item.price * item.quantity * days
        const discountValue = base * (item.discount / 100)

        totalDiscount += discountValue

        if (item.discount > 0) {
          discounts.push(item.discount)
        }

      })

      if (!discounts.length) {
        return {
          text: "0%",
          amount: "0.00"
        }
      }

      const min = Math.min(...discounts)
      const max = Math.max(...discounts)

      return {
        text: min === max ? `${min}%` : `${min}% - ${max}%`,
        amount: totalDiscount.toFixed(2)
      }

    },
    discountAmount() {

      if (!this.order) return 0

      return (this.order.paymentAmount - this.order.endPrice).toFixed(2)

    }

  },

  methods: {

    async load() {

      if (!this.orderId) return

      this.loading = true

      try {

        const {data} = await axios.get(`/api/order/${this.orderId}`)
        this.order = data

      } catch (e) {

        console.error(e)

      } finally {

        this.loading = false

      }

    },

    formatDate(date) {

      return new Date(date).toLocaleDateString("ru-RU")

    },

    statusName(status) {

      if (status === 1) return "Бронь"
      if (status === 2) return "Активный"
      if (status === 3) return "Выполнен"

      return "-"

    },
    getDaysDifference(date1, date2) {
      var d1 = new Date(date1);
      var d2 = new Date(date2);
      var diffInMilliseconds = Math.abs(d2 - d1);
      var diffInDays = Math.ceil(diffInMilliseconds / (1000 * 60 * 60 * 24));
      return diffInDays;
    },

    itemTotal(item, order) {

      const total = item.price * item.quantity * this.getDaysDifference(order.rentStartDate.date,order.rentEndDate.date)
      const discount = total * (item.discount / 100)

      return ((total - discount)).toFixed(2)

    }

  }

}
</script>


<style scoped>

.modal-overlay{
  position:fixed;
  top:0;
  left:0;
  width:100%;
  height:100%;
  background:rgba(0,0,0,.4);
  display:flex;
  justify-content:center;
  align-items:center;
  z-index:9999;
}

.modal-dialog{
  background:white;
  width:900px;
  max-width:95%;
  border-radius:10px;
  box-shadow:0 10px 30px rgba(0,0,0,.2);
  overflow:hidden;
}

.modal-header{
  display:flex;
  justify-content:space-between;
  align-items:center;
  padding:5px 20px;
  border-bottom:1px solid #eee;
  background:#fafafa;
}

.close-btn{
  border:none;
  background:none;
  font-size:20px;
  cursor:pointer;
}

.modal-body{
  padding: 20px;
  overflow-y: scroll;
  max-height: 90vh;
  height: 90vh;
}

.order-meta{
  display:grid;
  grid-template-columns:1fr 1fr;
  gap:5px 40px;
  background:#f2f5fb;
  padding:5px;
  border-radius:8px;
  margin-bottom:5px;
}

.meta-row{
  display:flex;
  flex-direction:column;
}

.meta-label{
  font-size:12px;
  color:#888;
}

.meta-value{
  font-size:14px;
  font-weight:600;
}

.meta-value.discount{
  color:#c0392b;
}

.client-card{
  display:grid;
  grid-template-columns:1fr 1fr;
  gap:5px 40px;
  background:#f7f9fc;
  padding:5px;
  border-radius:8px;
  margin-bottom:5px;
}

.client-row{
  display:flex;
  flex-direction:column;
}

.client-label{
  font-size:12px;
  color:#888;
}

.client-value{
  font-size:14px;
  font-weight:600;
}

.products-table{
  width:100%;
  border-collapse:collapse;
  margin-bottom:5px;
}

.products-table th{
  text-align:left;
  padding:10px;
  background:#f5f5f5;
  font-weight:600;
}

.products-table td{
  padding:10px;
  border-bottom:1px solid #eee;
}

.product-name{
  font-weight:500;
}

.discount-badge{
  background:#ffe5e5;
  color:#cc0000;
  padding:3px 8px;
  border-radius:4px;
  font-size:12px;
}

.totals{
  border-top:1px solid #eee;
  padding-top:5px;
}

.totals-grid{
  display:grid;
  grid-template-columns:1fr 1fr;
  gap:5px 40px;
  margin-bottom:5px;
}

.total-row{
  display:flex;
  justify-content:space-between;
}

.total{
  font-weight:bold;
}

.discount{
  color:#c0392b;
}

.paid{
  color:#27ae60;
  font-weight:bold;
}

</style>